// extracted by mini-css-extract-plugin
export default {"board":"GameBoard_board__FBQkC","info":"GameBoard_info__xJdkC"};